import {Component, Input} from '@angular/core';
import {DamsNameImportItem} from "../../../core/definitions/dams-import-data";
import {FormsModule} from "@angular/forms";
import {MatRadioButton, MatRadioChange, MatRadioGroup} from "@angular/material/radio";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-operation-view-dams-import-name',
    imports: [
        FormsModule,
        MatRadioGroup,
        MatRadioButton,
        TranslateModule
    ],
    templateUrl: './operation-view-dams-import-name.component.html',
    styleUrl: './operation-view-dams-import-name.component.scss'
})
export class OperationViewDamsImportNameComponent {
  @Input() nameItems: DamsNameImportItem[] = [];

  selectionChanged(event: MatRadioChange, item: DamsNameImportItem) {
    if (event.value === 'create') {
      item.create_new = true;
    }
    else {
      item.create_new = false;
      item.selected_suggestion = event.value;
    }
  }
}
